<div class="main-content table-page table-page--compact inventario-ia-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Consulta de Inventario de Activos IA</h1>
        <p>Vista de solo lectura del inventario (ISO/IEC 42001 · FDS-043).</p>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <mat-form-field appearance="outline" class="table-page__field table-page__filter table-page__filter--wide">
            <mat-label>Buscar por nombre</mat-label>
            <input matInput aria-label="Buscar por nombre" [(ngModel)]="filtro.nombreIa" (keyup.enter)="consultar()" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field table-page__filter table-page__filter--medium">
            <mat-label>Etapa del ciclo de vida</mat-label>
            <mat-select [(ngModel)]="filtro.idCicloVida">
              <mat-option [value]="null">Todas</mat-option>
              <mat-option *ngFor="let c of ciclosVida" [value]="c.idCicloVida">{{ c.nombre }}</mat-option>
            </mat-select>
          </mat-form-field>

        </div>

        <div class="table-page__toolbar-actions">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="limpiar()"><i class="material-icons">refresh</i><span>Limpiar</span></button>
          <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="consultar()"><i class="material-icons">search</i><span>Buscar</span></button>
        </div>
      </div>

      <div class="table-page__table-wrap">
        <table class="table-page__table table-page__table--wide" *ngIf="inventariosVisibles().length > 0; else emptyState">
          <thead>
            <tr>
              <th>#</th><th>IA / Sistema</th><th>Versión</th><th>Propietario</th>
              <th>Ciclo de vida</th><th>Supervisión humana</th><th>Estatus</th>
              <th class="table-page__actions-head">Detalle</th>
            </tr>
          </thead>
          <tbody>
            <!-- El Enter de la fila sólo actúa con la fila enfocada y devuelve null, no false:
                 con false Angular cancelaría el Enter del botón de detalle. -->
            <tr *ngFor="let item of inventariosPagina()" class="is-clickable" (click)="verDetalle(item)"
                (keydown.enter)="$event.target === $event.currentTarget ? verDetalle(item) : null">
              <td><span class="table-page__subtext">{{ item.consecutivo || item.idInventarioIa }}</span></td>
              <td><strong class="table-page__name">{{ item.nombreIa }}</strong></td>
              <td><span class="table-page__text">{{ item.version || "—" }}</span></td>
              <td><span class="table-page__text">{{ obtenerPropietario(item) }}</span></td>
              <td><span class="table-page__text">{{ item.cicloVidaNombre || "—" }}</span></td>
              <td><span class="table-page__text">{{ item.nivelSupervisionNombre || "—" }}</span></td>
              <td><span class="table-page__status-badge" [ngClass]="item.estatus === 'ACTIVO' ? 'is-active' : 'is-inactive'">{{ item.estatus }}</span></td>
              <td class="table-page__actions">
                <button type="button" class="table-page__action-btn" (click)="verDetalle(item); $event.stopPropagation()" title="Ver detalle">
                  <i class="material-icons">visibility</i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #emptyState>
          <div class="table-page__empty" *ngIf="!loading; else loadingState">
            <i class="material-icons">smart_toy</i>
            <strong>No hay activos registrados</strong>
            <span>No se encontraron registros con los filtros actuales.</span>
          </div>
        </ng-template>
        <ng-template #loadingState>
          <div class="table-page__empty table-page__empty--loading"><i class="material-icons">hourglass_top</i><strong>Cargando inventario…</strong></div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="!loading && inventariosVisibles().length > 0">
        <div class="table-page__meta">Mostrando {{ rangoInicio() }}–{{ rangoFin() }} de {{ inventariosVisibles().length }}</div>
        <nav class="table-page__pager" aria-label="Paginación">
          <button type="button" class="table-page__pager-link" (click)="primeraPagina()" [disabled]="paginaNorm() <= 1" title="Primera página" aria-label="Primera página"><span class="material-icons">first_page</span></button>
          <button type="button" class="table-page__pager-link" (click)="paginaAnterior()" [disabled]="paginaNorm() <= 1" title="Página anterior" aria-label="Página anterior"><span class="material-icons">chevron_left</span></button>
          <ng-container *ngFor="let p of getPaginationItems()">
            <button *ngIf="isPageNumber(p)" type="button" class="table-page__pager-page" [class.is-current]="p === paginaNorm()" (click)="irPagina(p)">{{ p }}</button>
            <span *ngIf="!isPageNumber(p)" class="table-page__pager-ellipsis">…</span>
          </ng-container>
          <button type="button" class="table-page__pager-link" (click)="paginaSiguiente()" [disabled]="paginaNorm() >= totalPaginas()" title="Página siguiente" aria-label="Página siguiente"><span class="material-icons">chevron_right</span></button>
          <button type="button" class="table-page__pager-link" (click)="ultimaPagina()" [disabled]="paginaNorm() >= totalPaginas()" title="Última página" aria-label="Última página"><span class="material-icons">last_page</span></button>
        </nav>
      </div>
    </section>
  </div>
</div>
